<template>
  <div class="wrapper">
    <v-text-field
    v-model="search"
    label="Hľadať podľa mena nájomníka"
    class="search"
    >
    </v-text-field>
    <v-data-table
        v-bind:headers="headers"
        :items="graves"
        :search="search"
        :custom-filter="customFilter"
        hide-actions
        class="elevation-0"
      >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left graveNumber">{{ props.item.properties.graveNumber }}</td>
        <td class="text-xs-left graveNumber">{{ props.item.properties.block }}</td>
        <td class="text-xs-left">{{ props.item.properties.graveType }}</td>
        <td class="text-xs-left graveName">{{ props.item.properties.owner }}</td>
        <td class="text-xs-left graveName">{{ props.item.properties.ownerAddress }}</td>
        <td class="text-xs-left">{{ props.item.properties.name }}</td>
        <td class="text-xs-left">{{ formatDate(props.item.properties.rentStart) }}</td>
        <td class="text-xs-left">{{ formatDate(props.item.properties.rentExpire) }}</td>
        <td class="text-xs-left">
          <v-btn depressed small color="primary" @click="editLayer(props.item.properties.id); closeDrawer()">
            <v-icon small>fa-pencil</v-icon>&nbsp; Upravit 
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'GraveManagement',
  props: ['graves'],
  data () {
    return {
      headers: [
        { text: 'Číslo hrobu', value: 'properties.graveNumber' },
        { text: 'Blok', value: 'properties.block' },
        { text: 'Typ hrobu', value: 'properties.graveType', sortable: false },
        { text: 'Nájomník', value: 'properties.owner', sortable: false },
        { text: 'Adresa nájomníka', value: 'properties.ownerAddress', sortable: false },
        { text: 'Mená pochovaných', value: 'properties.name', sortable: false },
        { text: 'Začiatok nájmu', value: 'properties.rentStartTs', dataType: "Date" },
        { text: 'Koniec nájmu', value: 'properties.rentExpireTs' },
        { text: '' }
      ],
      search: ''
    }
  },
  methods: {
    editLayer: function (id) {
      this.$emit('getLayerInfo', id)
    },
    closeDrawer: function () {
      this.$emit('closeDrawer')
    },
    customFilter: function (items, search, filter) {
      search = search.toString().toLowerCase()
      return this.$props.graves.filter(row => filter(row.properties.owner, search))
    },
    formatDate(value) {
      if (!value) return null
      return moment(value, 'DD-MM-YYYY').format('DD.MM.YYYY')
    }
  }
}
</script>
<style scoped>
.state {
  /* float: right; */
}
.wrapper {
  height: -webkit-fill-available;
  width: -webkit-fill-available;
  display: none;
  z-index: 5;
  background: #ffffff;
}
.graveNumber{
  width: 20px;
}

.graveName {
  width: 50px;
}

.search {
  margin-left: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/GraveManagement.vue